var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#0065FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4836 22.9314C9.96072 23.4541 9.66691 24.163 9.66675 24.9023V26.3332H11.0976C11.8369 26.333 12.5458 26.0392 13.0685 25.5164L22.3679 16.217L19.7829 13.6321L10.4836 22.9314Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7975 10.2024C25.6278 10.0325 25.4263 9.89774 25.2044 9.80579C24.9826 9.71383 24.7448 9.6665 24.5047 9.6665C24.2645 9.6665 24.0268 9.71383 23.8049 9.80579C23.5831 9.89774 23.3816 10.0325 23.2118 10.2024L20.7684 12.6466L23.3533 15.2316L25.7975 12.7881C25.9674 12.6184 26.1022 12.4168 26.1941 12.195C26.2861 11.9732 26.3334 11.7354 26.3334 11.4952C26.3334 11.2551 26.2861 11.0173 26.1941 10.7955C26.1022 10.5737 25.9674 10.3721 25.7975 10.2024Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionButton);
export default __webpack_public_path__ + "static/media/Action Button.7f782be91ec65888e8a1e845ce9ada57.svg";
export { ForwardRef as ReactComponent };